<template>
  <tr>
  	<td v-if="showCode">{{item.item_code}}</td>
    <td>{{item.title}}</td>
    <td>{{item.unit_name}}</td>
    <td class="text-xs-right" v-if="!viewMode">
      <v-edit-dialog :return-value="quantity" lazy @open="open" @close="close"> {{ item.quantity }}
        <v-text-field type="number" :rules="quantityRules" slot="input" v-model="quantity" label="Enter Quantity" single-line></v-text-field>
      </v-edit-dialog>
    </td>
    <td v-else class="text-xs-right">{{ item.quantity }}</td>
    <td class="text-xs-right" v-if="!viewMode">
      <v-edit-dialog :return-value.sync="rate" lazy @open="openRate" @close="closeRate"> {{ item.rate | roundValue }}
        <v-text-field type="number" :rules="rateRules" slot="input" v-model="rate" label="Enter Rate" single-line></v-text-field>
      </v-edit-dialog>
    </td>
    <td v-else class="text-xs-right">{{ item.rate | roundValue }}</td>
    <td class="text-xs-right">{{ item.tax_percent }}</td>
    <td class="text-xs-right">{{ item.total | roundValue }}</td>
    <td class="align-right justify-end layout px-2" v-if="!viewMode">
      <v-btn flat icon @click="$emit('delete', index)">
        <v-icon color="red">clear</v-icon>
      </v-btn>
    </td>
  </tr>
</template>
<script>
export default {
  name: 'PurchaseItem' ,
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    viewMode: {
      type: Boolean,
      default: false
    },
    showCode: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      quantity: 1,
      rate: 0,
      quantityRules: [
        v => !!v || 'Quantity is required',
        v => /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Quantity must be valid'
      ],
      rateRules: [
        v => !!v || 'Rate is required',
        v => /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Rate must be valid'
      ]
    }
  },
  
  methods: {
  	open () {
      this.quantity = this.item.quantity
    },
    close () {
      this.item.quantity = this.item.allow_decimal ? parseFloat(this.quantity) : parseInt(this.quantity)
    },
    openRate () {
      this.rate = this.item.rate
    },
    closeRate () {
      this.item.rate = parseFloat(this.rate)
    }
  },

  mounted () {
  	this.item.total = this.item.quantity * ( this.item.rate + ( ( this.item.rate * this.item.tax_percent ) / 100) )
  },

  computed: {
    
    itemTotal () {
      return this.item.quantity * ( this.item.rate + ( ( this.item.rate * this.item.tax_percent ) / 100) )
    }

  },

  watch: {

    itemTotal (val) {
      this.item.total = val
    },
  	
    'item.quantity' (val, oldVal) {
  		if (!val || val <= 0) {
        this.item.quantity = 1
  		}
  	},
    
    'item.rate' (val, oldVal) {
      if (!val || val <= 0) {
        this.item.rate = 0
      }
    }
    
  }
}
</script>